/*
 * FileName : page500.tsx
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-07-21 10:49:22
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */


// eslint-disable-next-line no-use-before-define
import React, { useEffect, useState } from 'react';
import { Result } from 'antd';


const SystemMaintenancePage = () => {
    const DEFUALT_CONTENT = 'The current system is under maintenance, please try again later!';
    const [ content, setContent ] = useState<string>(DEFUALT_CONTENT);


    useEffect(() => {
        const lang = localStorage.getItem('language');

        if (lang?.includes('en')) {
            setContent(DEFUALT_CONTENT);
        } else {
            setContent('Actualmente el sistema está en mantenimiento, inténtelo de nuevo más tarde!');
        }
    }, []);

    return (
        <Result
            status='info'
            title={content}
            // subTitle={Mes['messageSystemMaintenance']}
        // extra={<Button type='primary'> <Link to='/'>Back Home</Link> </Button>}
        />
    );
};

export default SystemMaintenancePage;


